import { defineMessages } from 'react-intl';

export default defineMessages({
  blog: {
    id: 'footer_blog',
    defaultMessage: 'Blog',
  },
  guidesTitle: {
    id: 'global_guides_link_tips',
    defaultMessage: 'Guides',
  },
  your: {
    id: 'footer_your_ads_in_trovit',
    defaultMessage: 'Your ads on Trovit',
  },
  about: {
    id: 'footer_acercade',
    defaultMessage: 'About us',
  },
  join: {
    id: 'global_joinUs',
    defaultMessage: 'Join us',
  },
  help: {
    id: 'footer_contactar',
    defaultMessage: 'Help',
  },
  privacy: {
    id: 'global_privacy_policy_title',
    defaultMessage: 'Privacy Policy',
  },
  cookie: {
    id: 'global_cookie_policy_title',
    defaultMessage: 'Cookie Policy',
  },
  legal: {
    id: 'global_legal_notice_title',
    defaultMessage: 'Legal Notice',
  },
  terms: {
    id: 'global_terms_and_conditions_title',
    defaultMessage: 'Terms and conditions',
  },
  followUs: {
    id: 'global_follow_us',
    defaultMessage: 'Follow Us',
  },
  topSearches: {
    id: 'global_busquedasfrecuentes',
    defaultMessage: 'Top Searches',
  },
  searchEnginesTitle: {
    id: 'global_footer_our_searchers',
    defaultMessage: 'Our search engines',
  },
  downloadAppTitle: {
    id: 'global_footer_download_app',
    defaultMessage: 'Download the app',
  },
});



// WEBPACK FOOTER //
// ./app/components/shared/Footer/messages.js